import React from 'react';

function AiIcon(props: React.SVGAttributes<{}>) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width="40" height="40" fill="white" />
            <path
                d="M25 15H21.6667M22.7022 7.29777L19.1667 10.8333M15 8.33333V5M10.8334 10.8334L7.29787 7.29787M8.33333 15H5M10.8334 19.1667L7.29787 22.7022M15 25V21.6667M33.3334 33.3334L20 20"
                stroke="#2E2E2E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default AiIcon;
